import { getAssetUrl } from "../api";

export default function Footer({ name, resumeUrl }) {
  const resumeHref = getAssetUrl(resumeUrl);

  return (
    <footer style={{
      padding: "2.5rem 3rem", borderTop: "1px solid var(--border)",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      fontSize: "0.8rem", color: "var(--text-muted)", flexWrap: "wrap", gap: "0.5rem",
    }}>
      <span>© {new Date().getFullYear()} {name}. All rights reserved.</span>
      <div style={{ display: "flex", gap: "1.5rem" }}>
        <a href="#home" style={{ color: "var(--text-muted)", transition: "color 0.2s" }}
          onMouseOver={e => e.target.style.color = "var(--text-main)"}
          onMouseOut={e => e.target.style.color = "var(--text-muted)"}
        >Back to top ↑</a>
        <a href={resumeHref || "#"} download={Boolean(resumeHref)} aria-disabled={!resumeHref} style={{ color: "var(--text-muted)", transition: "color 0.2s", pointerEvents: resumeHref ? "auto" : "none", opacity: resumeHref ? 1 : 0.55 }}
          onMouseOver={e => e.target.style.color = "var(--text-main)"}
          onMouseOut={e => e.target.style.color = "var(--text-muted)"}
        >Resume / CV</a>
      </div>
    </footer>
  );
}
